// Section 12: Fever. 50% of illness rolls; 2 seasons untreated, 1 treated; death 5% per
// season untreated (12% for elders and children); contagious. Constants: config.illnesses.fever.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { isChild, isElder } from '../../core/queries';
import { noDeltas } from '../../core/content-helpers';
import { defineIllness } from '../../core/registry';

export function fever(config: Config) {
  const c = config.illnesses.fever;

  return defineIllness({
    id: 'fever',
    label: 'Fever',
    section: 'S12',
    source: 'roll',
    weight: c.weight,
    untreatedSeasons: c.untreated,
    treatedSeasons: c.treated,
    deathChance: c.death,
    contagious: true,
    modifierTargets: ['illnessDeath'],
    modifiers(ctx, target) {
      if (target.kind !== 'illnessDeath' || target.illnessId !== 'fever') return [];
      const p = ctx.state.people[target.personId];
      if (p === undefined || !(isChild(ctx.cfg, p) || isElder(ctx.cfg, p))) return [];
      return [mod.set('illness:fever', c.deathVulnerable, 'elders and children')];
    },
    onCatch: (ctx, person) => [
      { kind: 'memory', personId: person.id, entry: { turn: ctx.season.turn, kind: 'fell-ill' } },
    ],
    onRecover: noDeltas,
  });
}
